import { formatDateUTCBr } from "@utils";
import { INotification } from "../../../providers/NotificationProvider";

const NotificationInterestAreaItem = ({
                                        driverName,
                                        originName,
                                        destinyName,
                                        assetName,
                                        createdAt,
                                        message,
                                      }: INotification) => {
  return (
    <div className="padding-y-15 padding-x-25 width-100pct">
      <div className="display-flex gap-15 align-items-center width-100pct">
        <div className="bg-success width-40 height-40 display-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style={{ minWidth: '40px', minHeight: '40px' }}>
          <span className="rioglyph rioglyph-polygon text-size-h4 text-color-white" />
        </div>

        <div className="flex-grow-1 width-100pct overflow-hidden">
          <div className="display-flex gap-10 align-items-center">
            <span className="text-bold text-size-14 line-height-20 text-capitalize">
              {driverName}
            </span>
            <div className="width-4 height-4 bg-black rounded flex-shrink-0" />
            <span className="text-bold text-size-14 text-color-success">
              Área de interesse
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-8">
            <span className="rioglyph rioglyph-calendar text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal">
              {formatDateUTCBr(createdAt)}
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-4">
            <span className="rioglyph rioglyph-start text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal word-break-word">
              {originName || "Ponto de partida"}
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-4">
            <span className="rioglyph rioglyph-finish text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal word-break-word">
              {destinyName}
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-4">
            <span className="rioglyph rioglyph-truck text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
            <span className="text-size-12 line-height-20 text-normal">
              {assetName}
            </span>
          </div>

          {message && (
            <div className="display-flex gap-4 align-items-start margin-top-4">
              <span className="rioglyph rioglyph-comment text-size-12 text-color-gray flex-shrink-0 margin-top-2" />
              <span className="text-size-12 line-height-20 text-italic word-break-word">
                {message}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationInterestAreaItem;
